import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {getRentalCarPrices} from "./frontend_script";
import {AJAX, hidePreloader, showPreloader} from "../functions";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import LoginPopup from "../popups/LoginPopup";
import ReasonPopup from "../popups/ReasonPopup";

class AlternativesPage extends Component {
	constructor(props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
		this.state = {
			showReasonPopup: false
		}
	}

	onSelect(id, loc, date) {

			let params = {};
			let t = this;

			params.action = 'api/booking/set_booking_alternative';
			params.uuid = this.props.uuid;
			params.variant = id + '-' + loc + '-' + date;

			AJAX(bm_ajax_url, 'POST', params, {
				func_callback: function (resp) {
					hidePreloader();
					if(resp.error !== undefined || resp.errors && resp.errors[0] !== undefined ) {
						let err = resp.error !== undefined ? resp.error :  resp.errors[0];
						showPopupWithGoBack(err);
					}
					else {
						t.props.handleSetSuccessPage(resp.messages);
						//showPopupWithGoBack('<img src="../../wp-content/plugins/booking-form/images/thumb-up-gecko.png" alt="gecko" style={{float:"left",margin:"0px 20px 0px 0px"}}>Your request has been sent. Thank you for choosing to Go with the Gecko.');
					}
				},
				response_json: true,
				func_waiting: function () {
					showPreloader();
				},
				func_error: function (resp) {
					showPopupWithGoBack(resp.message);
					hidePreloader();
				}
			});


	}

	onDecline(e) {
		e.preventDefault();
		this.setState({showReasonPopup: true});
	}


	render() {
		let vehicles = this.props.alternatives;

		return (<>
			<RedirectOnlyHome />

			<div id={'id_vehicles_div'} className={'vehicles'} style={{padding: "20px 15px", marginBottom: "25px"}}>

				<div className="row">
					{
						( Object.keys(vehicles).length > 0) ?
							(
								<div className="col text-center alternatives">
									<div className="row match_vehicles justify-content-end">
										<div className="col-md-6 match_vehicles_header">
											<strong>Your Available Vehicles</strong>
										</div>
										<div className="col-md-3"></div>
									</div>
									<div className="row match_vehicles" style={{marginBottom: "15px"}}>
									{
										vehicles.map((v) => {
											const truck_picture = {
												backgroundImage:`url(${v.picture})`,
												zIndex: '100'
											};

												return (
													<div className="col-md-6" id={v.id} style={{backgroundColor: "#d63545",marginBottom: "15px"}} key={v.id}>
														<div className="row" style={{backgroundColor: "#eeeeee",marginLeft: "0px",marginRight: "0px"}}>
															<div className="col-md-5 truck-picture" style={truck_picture}>
																{
																	v.discount > 0  &&
																	<span className='discount-wrapper'>Discount: {v.discount}$</span>
																}
															</div>
															<div className="col-md-7">
																<h3 style={{marginBottom: "5px"}}>{v.location_name_raw[0]}</h3>
																<h4>{v.location_name_raw[1]}</h4>
																<p>Pickup Date:  <b>{v.pickupdate}</b></p>
																<p>Dropoff Date: <b>{v.pickupdate}</b></p>

																<h3 style={{paddingTop: "20px"}}>{v.name}</h3>
																<p className="description">{v.description}</p>
																<p>
																	{
																		v.volume &&
																		<span className="volume"><i className="fas fa-box-open"></i>{v.volume}</span>
																	}
																	<span className="passengers"><i className="fas fa-user"></i>{v.passengers}</span>
																</p>
																<p className="description additional-info">{v.additional_descr}</p>
																<p>
																	<input type="button"
																		   className={'btn btn-success'}
																		   value="Select"
																		   onClick={(e)=>{this.onSelect(v.vehiclecategoryid, v.location_id, v.pickupdate_int)}}
																	/>
																</p>
															</div>
														</div>
													</div>
												)
											}
										)
									}
									</div>

									<p style={{textAlign:"left",maxWidth:"1000px",margin:"0 auto"}}>If you would prefer to not accept this upgrade, please select the following decline button, and suggest a reason why.</p>
									<p style={{textAlign:"left",maxWidth:"1000px",margin:"10px auto"}}>
										<input type="button" className={'btn btn-danger'}
											   value="Decline"
											   onClick={(e)=>{this.onDecline(e)}}
										/>
									</p>

									<ReasonPopup
										uuid={this.props.uuid}
										show={this.state.showReasonPopup}
										handleClose={()=>this.setState({showReasonPopup: false})}
										handleSetSuccessPage = {this.props.handleSetSuccessPage}
									/>
							</div>
							) :
							(
								<div className="col text-center">
									<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
										 alt="gecko headset"
										 className="alignleft" />
									<p style={{color: "#d63545", fontSize: "18px"}}><strong>No Vehicles Available</strong></p>
									<p>Our system currently isn't showing any available vehicles at that location during this time period. Please contact Go With The Gecko on <a href="tel:1300 826 883">1300 826 883</a> and we will be able to help identify a quick easy solution to your booking needs.</p>
									<p><a href="tel:1300826883" className="btn btn-green">Call 1300 826 883</a></p>
								</div>
							)
					}
				</div>
			</div>
		</>);
	}
}

export default AlternativesPage;
